import React from 'react';

export const TelephoneIcon = ({color, width, height}: any) => {
  return (
    <svg
      version="1.1"
      baseProfile="basic"
      id="Layer_1"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width={width}
      height={height}
      viewBox="0 0 90 90">
      <path
        d="M38.789,51.211l10.876,10.876c0.974,0.974,2.471,1.194,3.684,0.543l13.034-6.997c0.964-0.518,2.129-0.493,3.07,0.066
	l19.017,11.285c1.357,0.805,1.903,2.489,1.268,3.933c-1.625,3.698-4.583,10.476-5.758,13.473c-0.247,0.631-0.615,1.209-1.127,1.652
	c-12.674,10.986-37.89-2.4-57.191-21.701C6.358,45.039-7.028,19.823,3.958,7.149c0.444-0.512,1.022-0.88,1.652-1.127
	c2.996-1.175,9.775-4.133,13.473-5.758c1.444-0.635,3.128-0.089,3.933,1.268l11.285,19.017c0.558,0.941,0.583,2.106,0.066,3.07
	L27.37,36.651c-0.651,1.213-0.431,2.71,0.543,3.684C27.913,40.335,38.789,51.211,38.789,51.211z"
      />
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
    </svg>
  );
};
